import React, { createContext, useState, useContext, useEffect } from 'react';
import { authService } from '../services/api';

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const storedUser = authService.getCurrentUser();
    if (storedUser) {
      setUser(storedUser);
    }
    setLoading(false);
  }, []);

  const login = async (username, password) => {
    try {
      const data = await authService.login(username, password);

      console.log('📝 Dados retornados do login:', data);

      // Se requer setup de OTP ou verificação, não salvar token ainda
      if (data.requiresOTPSetup || data.requiresOTP) {
        console.log('🔐 Requer OTP:', { requiresOTPSetup: data.requiresOTPSetup, requiresOTP: data.requiresOTP });
        return {
          success: false,
          requiresOTPSetup: data.requiresOTPSetup,
          requiresOTP: data.requiresOTP,
          tempToken: data.tempToken,
          ultimo_ip_login: data.ultimo_ip_login,
          ultimo_login_at: data.ultimo_login_at
        };
      }

      setUser(data.user);
      return { success: true, user: data.user };
    } catch (error) {
      console.error('❌ Erro no login:', error);
      return {
        success: false,
        error: error.response?.data?.error || 'Erro ao fazer login'
      };
    }
  };

  const verifyOTP = async (tempToken, otpCode) => {
    try {
      const data = await authService.verifyOTP(tempToken, otpCode);
      setUser(data.user);

      // Salvar dados do login anterior para o popup de segurança
      if (data.loginAnterior) {
        localStorage.setItem('loginAnterior', JSON.stringify(data.loginAnterior));
      }

      return { success: true, user: data.user, loginAnterior: data.loginAnterior };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || 'Erro ao verificar OTP'
      };
    }
  };

  const logout = () => {
    authService.logout();
    setUser(null);
  };

  const hasRole = (...roles) => {
    return user && roles.includes(user.role);
  };

  const isAdminOrDiretor = () => {
    return hasRole('admin', 'diretor');
  };

  const value = {
    user,
    login,
    verifyOTP,
    logout,
    loading,
    isAuthenticated: !!user,
    hasRole,
    isAdminOrDiretor
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth deve ser usado dentro de um AuthProvider');
  }
  return context;
};

export default AuthContext;
